import { useMutation } from 'react-query';
import { useToast } from 'hooks/useToast';
import AuthAPI from 'services/API/AuthAPI';

/**
 * Sends a verification email to the logged in user.
 */
export const useSendVerificationEmail = () => {
  const { renderCustomToast: toast } = useToast();

  return useMutation(
    async () => {
      await AuthAPI.postVerifyEmail();
    },
    {
      onError: (e: any) => {
        toast({
          title: 'Error',
          description: e.response.data.message || 'Please try again later.',
          status: 'error',
          duration: 9000,
          isClosable: true,
        });
      },
      onSuccess: () => {
        toast({
          title: 'Verification Email Sent',
          description: 'Please check your inbox to verify your email.',
          status: 'success',
          duration: 9000,
          isClosable: true,
        });
      },
    },
  );
};
